import { QueryClient } from '@tanstack/react-query';
import { isAuthQueryError } from '@/lib/performSignOut';

/**
 * Defaults mirror v1 (`Clinio/src/App.tsx`) so cache behavior stays predictable
 * during the cutover. Modules can override per-query as needed.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
        retry: (failureCount, error) => {
          if (isAuthQueryError(error)) return false;
          return failureCount < 2;
        },
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30_000),
      },
      mutations: {
        // Mutations are not idempotent (payments, reschedule, etc.). Never retry
        // a deterministic 4xx — including PostgREST 400 from RPC validation.
        retry: false,
      },
    },
  });
}
